/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { getEventId, getEventName } from '@e180/domain/lib/event/util';

import { sendLoginLinkWithUsername } from 'src/shared/app/authentication/action/support/supportLoginLinkActions';
import { getAuthenticationUsername } from 'src/shared/app/authentication/selector/base/appAuthenticationBaseSelectors';
import { throwFormikSubmissionError } from 'src/shared/app/base/form/util/formUtil';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import LoginLinkFormDumb from './LoginLinkFormDumb';

import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  // $FlowIssue
  intl: intlShape,
};

const mapStateToProps = (state: State, { intl }: Props): Object => {
  const event = getEventSafely(state);

  return {
    email: getAuthenticationUsername(state),
    eventName: getEventName(event, intl.locale),
    // Used in `mergeProps` only
    event,
  };
};

const mapDispatchToProps = (dispatch: any): Object => ({ dispatch });

const mergeProps = (stateProps: Object, { dispatch }: Object): Object => {
  const { event } = stateProps;

  return {
    ...stateProps,
    handleSubmit({ email }: Object) {
      return dispatch(
        sendLoginLinkWithUsername(email, getEventId(event)),
      ).catch((e) => {
        throwFormikSubmissionError(e);
      });
    },
  };
};

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(LoginLinkFormDumb);
